import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import JnlpFileCell from "./JnlpFileCell.js";
import TableCellText from "./core/TableCellText.js";

const SystemSessionNameCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value || !props.data) {
    return null;
  }
  const { context } = props;
  const adminContext = context.adminContext;

  if (!adminContext) {
    return <JnlpFileCell {...props} />;
  } else {
    return <TableCellText {...props} />;
  }
};

export default SystemSessionNameCell;
